type GeneralHelpPageProps = object;

export const GeneralHelpPage: React.FC<GeneralHelpPageProps> = () => {
  return (
    <div className="container-fluid min-vh-80">
      <h3 className="page-caption mb-3">Hilfe</h3>
      <div className="col-xxl-9 col-xl-9 col-lg-9 col-xs-9 mt-0 p-0">
        <p>
          Auf dieser Seite finden Sie hilfreiche PDF-Dokumente zur
          ADM-Sperrdatei, darunter Satzbeschreibungen, rechtliche Hinweise,
          relevante Erklärungen und Verzeichnisse sowie das Benutzerhandbuch.
        </p>
        <ul className="download-list">
          <li>
            <a href="/files/Satzbeschreibung_ADMSperrdatei_Download.pdf">
              <i className="bi bi-box-arrow-down"></i> Satzbeschreibung der
              ADM-Sperrdatei (Download)
            </a>
          </li>
          <li>
            <a href="/files/Satzbeschreibung_ADMSperrdatei_Upload.pdf">
              <i className="bi bi-box-arrow-down"></i> Satzbeschreibung für den
              Datei-Upload
            </a>
          </li>
          <li>
            <a href="/files/ADMSperrdatei_Privat_Gewerblich_Kennzeichen.pdf">
              <i className="bi bi-box-arrow-down"></i>{" "}
              Privat-Gewerblich-Kennzeichen in der ADM-Sperrdatei
            </a>
          </li>
          <li>
            <a href="/files/Zweckbestimmung_und_Umgang_mit_der_ADM_Sperrdatei_Stand_11.05.2021.pdf">
              <i className="bi bi-box-arrow-down"></i> Zweckbestimmung und
              Umgang mit der ADM-Sperrdatei
            </a>
          </li>
          <li>
            <a href="/files/ADMSperrdatei_Rufnummernblöcke.pdf">
              <i className="bi bi-box-arrow-down"></i> Sperrung von
              Rufnummernblöcken
            </a>
          </li>
          <li>
            <a href="/files/ADMSperrdatei_Rufnummernaufbau.pdf">
              <i className="bi bi-box-arrow-down"></i> Rufnummernaufbau
            </a>
          </li>
          <li>
            <a href="/files/ADMSperrdatei_Vorwahlenverzeichnis.pdf">
              <i className="bi bi-box-arrow-down"></i> Vorwahlenverzeichnis
              Festnetz
            </a>
          </li>
          <li>
            <a href="/files/ADMSperrdatei_Mobilfunkvorwahlen2025.pdf">
              <i className="bi bi-box-arrow-down"></i> Vorwahlenverzeichnis
              Mobilfunk
            </a>
          </li>
          <li>
            <a href="/files/ADMSperrdatei_Datenschutzsrecht_30.12.2025.pdf">
              <i className="bi bi-box-arrow-down"></i> Datenschutz
            </a>
          </li>
          <li>
            <a href="/files/ADMSperrdatei_Handbuch_260112.pdf">
              <i className="bi bi-box-arrow-down"></i> Handbuch der
              ADM-Sperrdatei Anwendung
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

// Satzbeschreibung der ADM-Sperrdatei (Download)
// Satzbeschreibung_ADMSperrdatei_Download.pdf
// Satzbeschreibung für den Datei-Upload
// Satzbeschreibung_ADMSperrdatei_Upload.pdf
// Privat-Gewerblich-Kennzeichen in der ADM-Sperrdatei
// ADMSperrdatei_Privat-Gewerblich-Kennzeichen.pdf
// Zweckbestimmung und Umgang mit der ADM-Sperrdatei
// Zweckbestimmung-und-Umgang-mit-der-ADM-Sperrdatei-Stand-11.05.2021.pdf
// Sperrung von Rufnummernblöcken
// ADMSperrdatei_Rufnummernblöcke.pdf
// Rufnummernaufbau
// ADMSperrdatei_Rufnummernaufbau.pdf
// Vorwahlenverzeichnis Festnetz
// ADMSperrdatei_Vorwahlenverzeichnis.pdf
// Vorwahlenverzeichnis Mobilfunk
// ADMSperrdatei_Mobilfunkvorwahlen2025.pdf
// Datenschutz
// folgt
// Handbuch der ADM-Sperrdatei Anwendung
// folgt
